import React, { Component } from 'react';
import ReactDOM from 'react-dom';

export default class CallToBook extends Component
{
    constructor(props) {
        super(props);

        this.state = {

        };
    }
    
    render()
    {
        return (
            <div className="w-100">
                <div className="card d-none d-lg-block">
                    <div className="card-body">
                        <div className="media">
                            <div className="mr-3"><i className="fa fa-3x fa-mobile-alt body-text-color"></i></div>
                            <div className="media-body">
                                <h4 className="body-font font-weight-bold primary-text mb-2 d-flex align-items-center">
                                    Book by phone
                                </h4>
                                <div className="font-small mb-0">
                                    {`To book this tour, please contact the ${this.props.siteLabel} Sales & Service Center toll-free at: `}
                                    <a href={"tel:" + this.props.phone_number}>
                                        <span className="font-weight-bold body-text-color">{this.props.phone_number}</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="d-lg-none">
                    <a href={"tel:" + this.props.phone_number} className="btn btn-primary btn-rounded btn-block">
                        <div className="font-weight-bold">Book by phone</div>
                        <div className="font-smaller">{this.props.phone_number}</div>
                    </a>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./resources/js/components/Shared/CallToBook.js